module.exports = __webpack_public_path__ + "img/moonlit.746387b0.png";